import React, { useEffect, useState } from 'react';

import { CharacterSheetInterface } from "@dndModels";
import { DamageType } from '@dndModels/Types';

import FlexBox from '@components/layout/FlexBox';
import CommonUtilities from '@utilities/common_utilities';
import SelectStringBox from '@components/input/selects/SelectStringBox';
import { DAMAGE_MULTIPLIER_OPTIONS, DAMAGE_TYPES } from '@dndModels/Constants';
import ImageFromString from '@dndComponents/display/ImageFromString';

interface Props {
  char: CharacterSheetInterface;
}

const common_util = CommonUtilities.getInstance();

export default function CharacterDMCustomizations({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);

  const customizations = char.customizations;

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderDTCustomization = (dt: DamageType) => {
    // debugger;
    const dm = char.mind.damage_multipliers.find(o => o.damage_type === dt);
    return (
      <FlexBox key={dt}>
        <FlexBox direction="row">
          <FlexBox xs_expand={0}>
            <ImageFromString image={dt} size={25} color="white" />
          </FlexBox>
          <FlexBox xs_expand={0} style={{ width: "30%"}}>
            <FlexBox direction="column">
              <FlexBox>{ dt }</FlexBox>
              { dm && 
                <FlexBox className="small_label gray">{ dm.multiplier === 0 ? "Immunity" : dm.multiplier === 0.5 ? "Resistance" : "Vulnerability" }</FlexBox>
              }
              { customizations.damage_multiplier_overrides[dt] !== undefined &&
                <FlexBox className="small_label gray">Overridden</FlexBox>
              }
            </FlexBox>
          </FlexBox>
          <FlexBox>
            <SelectStringBox 
              name="Override"
              value={ customizations.damage_multiplier_overrides[dt] === undefined ? "Don't Override" : `${customizations.damage_multiplier_overrides[dt]}` } 
              options={DAMAGE_MULTIPLIER_OPTIONS}
              extra_options={["Don't Override"]}
              onChange={ async (changed: string) => {
                if (changed === "Don't Override") {
                  delete customizations.damage_multiplier_overrides[dt];
                } else {
                  customizations.damage_multiplier_overrides[dt] = +changed;
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
        </FlexBox>
      </FlexBox>
    );
  }

  return (
    <FlexBox direction="column">
      { DAMAGE_TYPES.filter(o => o !== "Typeless" && o !== "Same as Main").map(dt => renderDTCustomization(dt))}
    </FlexBox>
  );
}

